import { useCallback } from 'react';

import { type ModalName } from '@/modals-names';

import { useModalsActions, useModalState } from './modals-store';
import { type ModalWrapperProps } from './types';

// Implementation of the useModal hook
export function useModal<Props extends ModalWrapperProps>(
  name: ModalName,
  props?: Props
) {
  const { isOpen, index = 1, props: currentProps } = useModalState(name) ?? {};

  const { open: openModal, close: closeModal } = useModalsActions();

  const open = useCallback(
    (innerProps?: Props) => {
      openModal(name, { ...props, ...innerProps });
    },
    [name, openModal, props]
  );

  const close = useCallback(() => {
    closeModal(name);
  }, [closeModal, name]);

  return {
    isOpen: isOpen ?? false,
    index,
    props: currentProps as Props,
    open,
    close,
  };
}
